// Tarjouksen laskenta. Puhtaat funktiot.

// HALF_UP kahteen desimaaliin (esim. 3 × 0,335 = 1,005 → 1,01). Pyöristys tehdään desimaalimerkkijonosta,
// jotta liukuluvun virhe (1,5 × 6,67 = 10,004999…) ei käännä puolikasta alaspäin; vastaa BigDecimal HALF_UP:ia.
export function round2(x) {
  if (x == null || isNaN(x)) return 0;
  const n = Number(x);
  const [int, frac] = Math.abs(n).toFixed(10).split('.');
  let cents = Number(int) * 100 + Number(frac.slice(0, 2));
  if (Number(frac[2]) >= 5) cents += 1;
  return ((n < 0 ? -1 : 1) * cents) / 100;
}

export function rowTotal(quantity, unitPrice) {
  if (quantity == null || unitPrice == null) return 0;
  return round2(Number(quantity) * Number(unitPrice));
}

export function rowsTotal(rows) {
  return round2((rows || []).reduce((sum, r) => sum + rowTotal(r.quantity, r.unitPrice), 0));
}

// Työmaan hinnoitellut rivit (lisähinnat eivät ole summassa)
export function pricedRows(site) {
  return ((site && site.rows) || []).filter(r => !r.conditional);
}

export function siteTotal(site) {
  return rowsTotal(pricedRows(site));
}

// Työmaiden summa. Lisähinnat eivät ole summassa.
export function quotationTotal(quotation) {
  if (!quotation) return 0;
  return round2((quotation.sites || []).reduce((sum, s) => sum + siteTotal(s), 0));
}

// Työrivin määrä ja yksikkö: menetelmän hinnoitteluperuste (työkohtainen numeroparametri, esim. putken pituus m).
// Ilman hinnoitteluperustetta työ on 1 erä. Sama sääntö kuin backendin OfferRow.pricedQuantity.
export function pricingDef(method) {
  if (!method || !method.pricingDefId) return null;
  return (method.attributes || []).find(d => d.id === method.pricingDefId) || null;
}

export function pricedQuantity(method, values) {
  const def = pricingDef(method);
  if (!def) return 1;
  const v = (values || []).find(x => x.defId === def.id);
  return v && v.valueNumber != null && v.valueNumber !== '' ? Number(v.valueNumber) : null;
}

export function pricedUnit(method) {
  const def = pricingDef(method);
  return def ? def.unit || '' : 'erä';
}

// Menetelmän työkohtaiset parametrit, kuten työmaan työllä
export function workDefs(method) {
  return ((method && method.attributes) || []).filter(d => d.scope === 'WORK');
}

// Nimikkeen hinta käyttöyksikköä kohti. Varastoyksiköllisen nimikkeen hinta on varastoyksikköä kohti (teräsputki €/kg),
// ja kerroin (kg/m) muuntaa sen käyttöyksikön hinnaksi (€/m) kuten varastokirjauksessa.
export function itemUnitPrice(item) {
  if (!item || item.price == null) return null;
  return item.warehouseUnit && item.conversionFactor ? round2(item.price * item.conversionFactor) : item.price;
}

// Yksikköhinnan yksikkö: lisähinnan yksikkö on valmiiksi muotoa €/m tai %
export function priceUnit(unit) {
  if (!unit) return '€';
  return unit.startsWith('€') || unit === '%' ? unit : `€/${unit}`;
}

export function formatAttrValue(value, def) {
  if (!value) return null;
  switch (def.valueType) {
    case 'NUMBER':
      return value.valueNumber != null ? String(value.valueNumber) : null;
    case 'BOOLEAN':
      return value.valueBoolean == null ? null : value.valueBoolean ? 'Kyllä' : 'Ei';
    case 'ITEMREF':
      return value.valueItem ? value.valueItem.name : null;
    case 'DATE':
      return value.valueDate || null;
    default:
      return value.valueText || null;
  }
}

// Sama logiikka kuin SiteView.generateWorkTitle: menetelmän nimi + ensimmäinen täytetty WORK-attribuutti.
export function workTitle(method, defs, values) {
  const parts = [];
  if (method && method.name) parts.push(method.name);
  const sorted = (defs || []).slice().sort((a, b) => (a.displayOrder || 0) - (b.displayOrder || 0));
  for (const d of sorted) {
    const v = (values || []).find(x => x.defId === d.id);
    const formatted = formatAttrValue(v, d);
    if (formatted != null && formatted !== '') {
      parts.push(formatted);
      break;
    }
  }
  return parts.join(' ');
}
